<template>
<div>
    <div class="default-settings-title">
        <span class="account-name">Step 3: Database details</span>
        <span class="default-settings-subtitle">{{ databaseDetailsStepDescription }}</span>
    </div>

    <div class="columns is-multiline">
        <div class="column is-full">
            <div class="backup" style="margin-bottom: 7px !important; margin-top: 15px !important;">
                <div class="columns is-multiline">
                    <!-- <div class="column is-4">
                        <div @click="selectDatabaseType('mysql')" class="backup-frequency backup-frequency-selectable" :class="{ 'backup-frequency-selected': databaseTypeIs('mysql') }">
                            <div class="icon-db">
                                <img src="/databases/mysql.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    MySQL
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div @click="selectDatabaseType('postgresql')" class="backup-retention backup-retention-selectable" :class="{ 'backup-frequency-selected': databaseTypeIs('postgresql') }">
                            <div class="icon-db">
                                <img src="/databases/postgresql.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    PostgreSQL
                                </div>
                            </diV>
                        </div>
                    </div> -->
                    <!-- <div class="column is-4">
                        <div @click="selectDatabaseType('mongodb')" class="backup-retention backup-retention-selectable" :class="{ 'backup-frequency-selected': databaseTypeIs('mongodb') }">
                            <div class="icon-db">
                                <img src="/databases/mongodb.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    MongoDB
                                </div>
                            </diV>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="column is-full">
            <div class="columns is-multiline">

                <div v-if="sshConnectionFailed" class="column is-full">
                    <div class="notification is-danger" style="font-size:13px;">Weap.io was not able to connect to the server via SSH. Was the given key added to the <b>~/.ssh/authorized_keys</b> file? If yes, maybe a firewall is limiting/blocking the access?</div>
                </div>
                
                <div v-if="wrongCredentials" class="column is-full">
                    <div class="notification is-danger" style="font-size:13px;">Weap.io was not able to connect to the database. Have you tried to use both <b>localhost</b> and <b>127.0.0.1</b> as host? Make sure the username, password, host, and port are correct.</div>
                </div>

                <div v-if="firstMissingPackage" class="column is-full">
                    <div class="notification is-danger" style="font-size:13px;"><b>{{ firstMissingPackage }}</b> is required. Install it on the server in order to proceed.</div>
                </div>

                <!-- <div class="column is-full">
                    <div class="notification is-info" style="font-size: 13px; margin-bottom: 15px; background-color: #25303F !important;">
                        CREATE USER '{{user}}'@'{{host}}' IDENTIFIED BY '{{password}}';
                        <br>
                        <br>
                        GRANT ALL ON *.* TO '{{user}}'@'{{host}}';
                        <br>
                        <br>
                        FLUSH PRIVILEGES;
                    </div>
                </div> -->

                <div class="column is-6">
                    <div class="field">
                        <input v-model="user" @keyup.enter="nextStep" type="text" class="input custom-input-size is-medium" :class="{ 'is-danger': hasError('user') }" placeholder="root" autocomplete="off" :disabled="checkingCredentials"/>
                        <span v-if="!hasError('user')" class="help">User of the database.</span>
                        <span v-if="hasError('user')" class="help is-danger">{{ getError('user') }}</span>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <input v-model="password" @keyup.enter="nextStep" type="text" class="input custom-input-size is-medium" :class="{ 'is-danger': hasError('password') }" placeholder="secret" autocomplete="off" :disabled="checkingCredentials"/>
                        <span v-if="!hasError('password')" class="help">{{ userInputDescription }}</span>
                        <span v-if="hasError('password')" class="help is-danger">{{ getError('password') }}</span>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <input v-model="host" @keyup.enter="nextStep" type="text" class="input custom-input-size is-medium" :class="{ 'is-danger': hasError('host') }" placeholder="127.0.0.1" autocomplete="off" :disabled="checkingCredentials"/>
                        <span v-if="!hasError('host')" class="help">Database host, usually 127.0.0.1 or localhost.</span>
                        <span v-if="hasError('host')" class="help is-danger">{{ getError('host') }}</span>
                    </div>
                </div>
                
                <div class="column is-6">
                    <div class="field">
                        <input v-model="port" @keyup.enter="nextStep" type="text" class="input custom-input-size is-medium" :class="{ 'is-danger': hasError('port') }" placeholder="3306" autocomplete="off" :disabled="checkingCredentials"/>
                        <span v-if="!hasError('port')" class="help">{{ portInputDescription }}</span>
                        <span v-if="hasError('port')" class="help is-danger">{{ getError('port') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-3">
            <div @click="nextStep" class="button custom-button-size is-fullwidth is-info" :class="{ 'is-loading': checkingCredentials }" :disabled="checkingCredentials">Next</div>
        </div>
        <div class="column is-3">
            <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="checkingCredentials">Cancel</div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    props: ['server', 'databaseType'],

    mixins: [FormErrorsMixin],

    data() {
        return {
            user: '',
            host: 'localhost',
            password: '',
            port: 3306,
            checkingCredentials: false,
            allowedInputs: ['user', 'host', 'password', 'port'],
            wrongCredentials: false,
            sshConnectionFailed: false,
            firstMissingPackage: null,
        }
    },

    mounted() {
        // this.password = this.randomString(16);
        // this.user = 'weap';
        if (this.databaseTypeIs('postgresql')) {
            this.port = 5432;
        }
    },

    methods: {
        checkCredentials(successCallback) {
            if (this.checkingCredentials) {
                return;
            }

            this.checkingCredentials = true;
            this.wrongCredentials = false;
            this.firstMissingPackage = null;
            this.sshConnectionFailed = false;
            this.resetErrors();

            if (this.databaseTypeIs('mysql')) {
                var endpoint = 'servers/' + this.server.id + '/mysql-credentials-status';
            } else if (this.databaseTypeIs('postgresql')) {
                var endpoint = 'servers/' + this.server.id + '/postgresql-credentials-status';
            }

            Api().put(endpoint, this.credentials)
                .then((success) => {
                    if (!success.data.ssh_connection_succeeded) {
                        this.sshConnectionFailed = true;
                    } else if (success.data.credentials_are_valid && !success.data.first_missing_package) {
                        if (typeof successCallback == 'function') {
                            successCallback();
                        }
                    } else if (!success.data.credentials_are_valid) {
                        this.wrongCredentials = true;
                    } else if (success.data.first_missing_package) {
                        this.firstMissingPackage = success.data.first_missing_package;
                    }
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.checkingCredentials = false;
                });
        },

        nextStep() {
            if (this.checkingCredentials) {
                return;
            }

            this.checkCredentials(() => {
                Event.$emit('moveToSelectDatabasesStep', this.credentials, this.databaseType);
            });
        },

        close() {
            if (this.checkingCredentials) {
                return;
            }

            Event.$emit('closeAddDatabase');
        },

        databaseTypeIs(type) {
            return type == this.databaseType;
        },

        selectDatabaseType(type) {
            this.databaseType = type;
        },

        randomString(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            return result;
        }
    },

    computed: {
        credentials() {
            return {
                user: this.user,
                host: this.host,
                password: this.password,
                port: this.port,
                type: this.databaseType,
            }
        },

        userInputDescription() {
            if (this.databaseType == 'mysql') {
                return 'The password of the MySQL user.';
            } else if (this.databaseType == 'postgresql') {
                return 'The password of the PostgreSQL user.';
            }
        },

        portInputDescription() {
            if (this.databaseType == 'mysql') {
                return 'Database port. The default one is 3306.';
            } else if (this.databaseType == 'postgresql') {
                return 'Database port. The default one is 5432.'
            }
        },

        databaseDetailsStepDescription() {
            if (this.checkingCredentials) {
                return 'Connecting to the database, this may take a while...';
            } else {
                return 'The details of the database connection.';
            }
        },
    },

    watch: {
        databaseType(databaseType) {
            if (databaseType == 'mysql' && this.port == 5432) {
                this.port = 3306;
            } else if (databaseType == 'postgresql' && this.port == 3306) {
                this.port = 5432;
            }
        },
    },
}
</script>